import React from 'react';
import ReceiptLongIcon from '@material-ui/icons/Receipt';
import PaymentIcon from '@material-ui/icons/Payment';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import CodeIcon from '@material-ui/icons/Code';
import DoorIcon from '@material-ui/icons/ExitToApp'
export const ASidebardata=[
    {
        title:"Gestão de Vendas",
        icon:<ReceiptLongIcon/>,
        link:"/admin/home/gestVendas"

    },{
        title:"Gestão de Pagamentos",
        icon:<PaymentIcon/>,
        link:"/admin/home/gestPagamento"

    },{
        title:"Gestão de Relatorios",
        icon:<EqualizerIcon/>,
        link:"/admin/home/gestRelatorios"

    },{
        title:"Logout",
        icon:<DoorIcon/>,
  
        link:"/"

    }


];